var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"form-group\"><div class=\"radio\"><label><input type=\"checkbox\" name=\"optIn\" ng-model=\"$ctrl.$cart.subscribeEmails\" ng-change=\"$ctrl.$cart.update('subscribeEmails')\" ng-true-value=\"'true'\" ng-false-value=\"'false'\"><large>Yes, please send me updates on new products and special deals!</large></label></div><br/></div>";
var id1="email-subscribe.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;